'use strict';

module.exports = require('./_source/linked-list.js');



//////////////////
// WEBPACK FOOTER
// ./~/linked-list/index.js
// module id = 1024
// module chunks = 31 32 33